/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Image_Compliance_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "Compliance checks for generated and uploaded images are turned off." |
*
* @param {Audit_Details_Image_Compliance_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_image_compliance_disabled_desc = /** @type {((inputs?: Audit_Details_Image_Compliance_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Image_Compliance_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Compliance-Prüfung für generierte und hochgeladene Bilder ist deaktiviert.")
	return /** @type {LocalizedString} */ ("Compliance checks for generated and uploaded images are turned off.")
});